import { z } from 'zod';
import { BaseFlowBlockSchema } from '../../block.js';
import { FlowSubflowV2BlockBaseSchema, FlowSubflowV2BlockConfigSchema, } from '../../subflow/v2/config.js';
import { FlowBlockType } from '../../type.js';
export const FlowSkillV2BlockConfigSchema = FlowSubflowV2BlockConfigSchema;
export const FlowSkillV2BlockBaseSchema = FlowSubflowV2BlockBaseSchema.extend({
    type: z.literal(FlowBlockType.SkillV2),
});
export const FlowSkillV2BlockSchema = BaseFlowBlockSchema.extend(FlowSkillV2BlockBaseSchema.shape);
//# sourceMappingURL=config.js.map